var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"noon-report-list"}},[_c('nprogress-container'),(!_vm.hasAddon)?_c('div'):_c('div',{staticClass:"vx-card p-8 noon-report-contents"},[_c('report-list-header',{ref:"ReportListHeader",on:{"clickButton":_vm.print}}),_c('report-list-body',{ref:"ReportListBody"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }